import { render } from "./PropertiesRank.vue?vue&type=template&id=cc934bf4&scoped=true"
import script from "./PropertiesRank.vue?vue&type=script&lang=js"
export * from "./PropertiesRank.vue?vue&type=script&lang=js"

import "./PropertiesRank.vue?vue&type=style&index=0&id=cc934bf4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc934bf4"]])

export default __exports__